/**
 * Read-Only Mode Banner
 * 
 * Displays a persistent banner when the site is in read-only mode
 */

import { useTranslation } from 'react-i18next';
import { BookOpen, X } from 'lucide-react';
import { useState } from 'react';

export default function ReadOnlyBanner({ message }) {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-blue-600 text-white px-4 py-2 flex items-center justify-center gap-3 shadow-lg">
      <BookOpen className="w-4 h-4 flex-shrink-0" />
      <span className="text-sm font-medium">
        {message || t('read_only_banner.message')}
      </span>
      <button
        onClick={() => setDismissed(true)}
        className="ml-4 p-1 hover:bg-white/20 rounded transition-colors"
        aria-label="Fechar"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
